import React from "react";

import Footer from "@components/layouts/b2c/onboarding/Footer";
import Navbar from "@components/layouts/b2c/onboarding/NavBar";
import { useAlertHandler } from "@utils/hooks/useAlertHandler";

export const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  const { alertRef, alert } = useAlertHandler();

  return (
    <div className="flex h-screen min-h-screen flex-col" dir="rtl" lang="ar">
      <div
        ref={alertRef}
        className={`fixed left-[50%] top-[20px] z-40 hidden w-[244px] translate-x-[-50%] rounded-md border-[1px] border-[#DD3333] bg-[#FFF7F7] px-2 py-2 text-[12px] font-normal text-[#E95252] opacity-0 transition-opacity`}
      >
        <p className="">{alert.messages?.[0].message}</p>
      </div>
      <div
        className="h-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url(/assets/images/wajeez_login_wallpaper.png)",
        }}
      >
        <div
          className={`flex h-full flex-col items-center justify-center`}
          style={{
            backgroundImage:
              "linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3))",
          }}
        >
          <Navbar />
          <main className="mb-auto flex w-full items-start justify-center px-4 py-[65px] sm:w-auto sm:px-0">
            {children}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};
